import React from 'react';
import { Route } from 'react-router-dom';

// page components of the app
import LexNavbar from './app/global/Navbar';
import Footer from './app/global/Footer';

import Home from './app/info/Home';
import Help from './app/info/Help';
import SignIn from './app/auth/SignIn';
import SignUp from './app/auth/SignUp';
import PersonalData from './app/auth/PersonalData';

import Dashboard from './app/dashboard/Dashboard';

import { ANALYTICS_URL, PERSONALDATA_URL, SIGNIN_URL, SIGNUP_URL, HELP_URL, HOME_URL } from './app/constants';


// TODO : manage the route to result page here, not in dashboard

const App = () => (
  <div className="wrapper">
    <LexNavbar />
    <div className="layout">
      <Route exact path={HOME_URL} component={Home} />
      <Route path={ANALYTICS_URL} component={Dashboard} />
      <Route path={SIGNIN_URL} component={SignIn} />
      <Route path={SIGNUP_URL} component={SignUp} />
      <Route path={PERSONALDATA_URL} component={PersonalData} />
      <Route path={HELP_URL} component={Help} />
      <Footer />
    </div>
  </div>
);

export default React.memo(App);
